/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PayByLinehaulType {
    PerMile = 1,
    PercOfLH = 2,
    Flat = 3,
    PerKM = 5,
    Tiered = 7,
    Hourly = 10,
    PercOfTotalRev = 11,
}
